export enum InputType {
  text = 'text',
  password = 'password',
  email = 'email',
  confirmPassword = 'confpassword',
  number = 'number'
}
